import React, { useState } from "react";
import Typewriter from "./TypeWriter";
import CopyButton from "./components/CopyButton";
import MessageTimestamp from "./components/MessageTimestamp";
import RegenerateButton from "./components/RegenerateButton";

const Message = ({ message, name, originalPrompt }) => {
  const [isTypewriterComplete, setIsTypewriterComplete] = useState(false);

  return (
    <div
      key={message.messageId}
      className="mb-2 md:mb-4 p-2 md:p-3 border-none group"
    >
      <div className="flex items-center justify-between px-2 mb-1">
        <div className="flex items-center gap-2">
          <h2 className="text-sm md:text-base text-[#3429B3] font-semibold">{name}</h2>
          <MessageTimestamp timestamp={message.timestamp} />
        </div>
        <div className="opacity-0 group-hover:opacity-100 transition-opacity">
          <CopyButton text={message.content} />
        </div>
      </div>
      <div className="break-words bg-white bg-opacity-30 border-none rounded-[20px] md:rounded-[25px] p-3 md:p-4 overflow-hidden relative">
        {message.senderName === "Zucky" ? (
          <div className="pb-1">
            <div className="mb-3">
              <Typewriter 
                text={message.content} 
                delay={10} 
                onUpdate={() => {
                  // Trigger parent scroll when typewriter updates
                  const event = new Event('typewriter-update');
                  window.dispatchEvent(event);
                }}
                onComplete={() => {
                  setIsTypewriterComplete(true);
                }}
              />
            </div>
            {isTypewriterComplete && (
              <div className="flex justify-end">
                <RegenerateButton messageId={message.messageId} originalPrompt={originalPrompt} />
              </div>
            )}
          </div>
        ) : (
          <p className="text-sm md:text-base max-w-full md:max-w-4xl leading-relaxed mb-0" style={{ wordWrap: "break-word" }}>
            {message.content}
          </p>
        )}
      </div>
    </div>
  );
};

export default Message;
